import React from 'react'
import { Link, useStaticQuery, graphql } from "gatsby"

const LatestEpisodes = () => {
  const data = useStaticQuery(graphql`
    query EpisodeCount {
      allFeedGatsbyBlog(sort: {fields: isoDate, order: DESC}) {
        totalCount
        edges {
          node {
            title
            enclosure {
              url
            }
          }
        }
      }
    }
  `)

  return(
    <section id="episodes" className="latest-episodes">
      <div className="podcast-container">
        <h2>Listen to our Latest Episode</h2>

        <iframe src="https://anchor.fm/thingsigotwrong/embed" className="podcast--iframe" title="Things I Got Wrong iframe" frameBorder="0" scrolling="no"></iframe>

        <Link to="/episodes">View all {data.allFeedGatsbyBlog.totalCount} episodes</Link>
      </div>
    </section>
  )
}
export default LatestEpisodes
